//#region types
import { EditableFormInnerProps } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import ReadOnlyRemovableFormInnerFields from "./readOnlyRemovableFormInnerFields";
import StyledButton from "../buttons/styledButton";
import { Grid } from "@mui/material";
import { useFormikContext } from "formik";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function ReadOnlyRemovableFormInner<T extends Record<string, any>>(props: EditableFormInnerProps<T>) {
  const { removeAllButtonText } = props;
  const { values, setValues } = useFormikContext<T>();

  const onClearAllClick = () => {
    props.onClickClearAll ? props.onClickClearAll(values, setValues) : setValues({} as T);
  }

  return (
    <Grid container spacing={2}>
      <ReadOnlyRemovableFormInnerFields {...props} />
      <Grid item>
        <StyledButton size="xs" onClick={onClearAllClick}>
          {LocalizationHelperInstance.getFormattedMessage(removeAllButtonText ?? TranslationKeys.Common.Clear)}
        </StyledButton>
      </Grid>
    </Grid>
  );
}

export default ReadOnlyRemovableFormInner;
